import msgboxVue from './index.vue'
const ConfirmBox: any = {}
ConfirmBox.install = function(Vue: any, options: any) {
  const ConfirmBoxInstance = Vue.extend(msgboxVue)
  let currentMsg: any
  const initInstance = () => {
    currentMsg = new ConfirmBoxInstance()
    const msgBoxEl = currentMsg.$mount().$el
    document.body.appendChild(msgBoxEl)
  }
  Vue.prototype.$msgBox = {
    showMsgBox(options: any) {
      if (!currentMsg) {
        initInstance()
      }
      if (typeof options === 'string') {
        currentMsg.content = options
      } else if (typeof options === 'object') {
        Object.assign(currentMsg, options)
      }
      return currentMsg
        .showMsgBox()
        .then((val: any) => {
          currentMsg = null
          return Promise.resolve(val)
        })
        .catch((err: any) => {
          currentMsg = null
          return Promise.reject(err)
        })
    },
  }
}
export default ConfirmBox
